import styles from './RawHTML.module.scss';

interface RawHTMLProps {
  html: string;
  className?: string;
}

export default function RawHTML({ html, className }: RawHTMLProps) {
  if (!html) return null;
  return (
    <div
      className={`overflow-hidden break-words ${styles.articleContent} ${className ?? ''}`}
      // Lark/Docx 后端返回的 bodyHtml 偶尔会含损坏的属性 / 截断的标签，浏览器解析出的 DOM 与
      // 服务端字符串可能不一致。React 18 在生产环境会自动重新渲染，不影响功能；这里抑制 dev
      // 警告，避免每次都弹红框。
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
